module.exports = __webpack_public_path__ + "img/truck_feature_02.8943a583.jpg";